<div>
  <po-lookup #lookupTarefas class="np po-xl-12 po-lg-12 po-md-12 po-sm-12" [p-columns]="columns"
    [p-disabled]="properties.includes('disabled')" [p-field-label]="fieldLabel" [p-field-value]="fieldValue"
    [p-field-format]="fieldFormat" [p-filter-service]="filterService || sampleFilterService"
    [p-filter-params]="fieldLabel" [p-help]="help" [p-literals]="customLiterals" [p-no-autocomplete]="true"
    [p-optional]="properties.includes('optional')" [p-required]="properties.includes('required')"
    (p-error)="changeEvent($event)" (p-selected)="changeEvent($event)">
  </po-lookup>
</div>
<div style="position: relative;margin-top: 1.5em;"
     class="np po-xl-12 po-lg-12 po-md-12 po-sm-12"
     *ngIf="sampleFilterService.IsSearching">
  <po-loading-overlay *ngIf="sampleFilterService.IsSearching" ></po-loading-overlay>
</div>
<div [hidden]="contextApplication.hiddenDashboardTaskInput[0]">
  <div class="po-row np">
    <p class="taskTitle npl po-xl-1 po-lg-1 po-md-1 po-sm-1" style="width: 5%">{{ literalsCp?.strTarefa | uppercase }}</p>
    <hr class="po-xl-11 po-lg-11 po-md-11 po-sm-11" style="margin-top: 30px; width: 95%" />
  </div>

  <div class="po-row np">
    <div class="circuloSucesso po-xl-1 po-lg-1 po-md-1 po-sm-1"><span class="po-icon po-icon-construction iconMiddle"
        style="margin-left: 8px; font-size: 20px;"></span>
    </div>
    <p class="taskDescripton po-xl-10 po-lg-10 po-md-10 po-sm-10">{{ taskDescription }}</p>
  </div>

  <div class="po-row">
    <p class="taskCod np po-xl-12 po-lg-12 po-md-12 po-sm-12">{{ literalsCp?.strCod | uppercase }} {{ taskCode}}</p>
  </div>

  <div>
    <cp-taskcharts [taskitem]="taskitem" [hiddenCharts]="false" class="po-row" style="margin-top: 1em;"></cp-taskcharts>
    <cp-task-input #taskinput [taskitem]="taskitem"></cp-task-input>
  </div>
</div>
